import { usePolicyDetail } from "data/ss-data-hooks";

export const usePropertyUpdatePool = () => {
  const { data, isLoading } = usePolicyDetail();

  return {
    loading: isLoading,
    prevPoolType: data?.userPropertyProfileData.poolType,
  };
};
